import React, { useState } from "react";
import { Box, Typography, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

// システムお知らせ設定
// 変更時はここを編集してビルド＆デプロイ
const NOTICES = [
  {
    id: "line-202604",
    message:
      "【新機能】LINE通知機能が追加されました。マスター → LINE設定 から設定できます。",
    color: "#1976d2",
    bgColor: "#e3f2fd",
  },
  {
    id: "maintenance-20260413",
    message:
      "【メンテナンス】4月13日(月) 早朝6:00〜7:00にデータベースのアップデートを行います。20〜30分ほど接続できなくなる場合がございます。",
    color: "#e65100",
    bgColor: "#fff3e0",
  },
];

const SystemNotice: React.FC = () => {
  const [dismissed, setDismissed] = useState<string[]>([]);

  const visibleNotices = NOTICES.filter((n) => !dismissed.includes(n.id));

  if (visibleNotices.length === 0) return null;

  return (
    <>
      {visibleNotices.map((notice) => (
        <Box
          key={notice.id}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          style={{
            backgroundColor: notice.bgColor,
            borderLeft: `4px solid ${notice.color}`,
            padding: "8px 16px",
          }}
        >
          <Typography
            variant="body2"
            style={{ color: notice.color, fontWeight: 500 }}
          >
            {notice.message}
          </Typography>
          <IconButton
            size="small"
            onClick={() => setDismissed([...dismissed, notice.id])}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      ))}
    </>
  );
};

export default SystemNotice;
